import type { Resource } from '../../';
export const footer_emailForm_message: Resource = {"default":"Stay Connected with Us"};
